const vimeoURLRegexp = /(https|http)?(:\/\/)?(www.)?(vimeo.com\/)?/;

export const getURLType = (url) => {
  const firstCrumb = url.replace(vimeoURLRegexp, '').split('/')[0];

  if (firstCrumb.includes('channels')) {
    return 'channel';
  }

  if (firstCrumb.includes('groups')) {
    return 'group';
  }

  if (firstCrumb.includes('ondemand')) {
    return 'page';
  }

  if (firstCrumb.includes('album')) {
    return 'album';
  }

  if (firstCrumb.includes('showcase')) {
    return 'album';
  }

  if (Number(firstCrumb, 10)) {
    return 'video';
  }

  if (!firstCrumb) {
    return 'empty';
  }

  return 'user';
};
